import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg } from "@/lib/api";

const blank = { imei: "", internal_number: "", brand: "", model: "", sim_imei: "", phone_number: "", station_id: "", notes: "", arrival_date: "" };
const F = ({ label, children, span }) => <div className={`space-y-1.5 ${span ? "sm:col-span-2" : ""}`}><Label>{label}</Label>{children}</div>;
const FIELDS = [["imei", "IMEI telefono"], ["internal_number", "Numero interno"], ["brand", "Marca"], ["model", "Modello"], ["sim_imei", "IMEI SIM"], ["phone_number", "Numero telefono"]];

export const PhoneDialog = ({ item, stations, isAdmin, onClose, onSaved }) => {
  const [f, setF] = useState(blank);
  const [saving, setSaving] = useState(false);
  useEffect(() => {
    if (item) setF({ ...blank, station_id: stations[0]?.id || "", ...item, arrival_date: item.arrival_date || "" });
  }, [item, stations]);
  if (!item) return null;
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      const payload = { ...Object.fromEntries(Object.keys(blank).map((k) => [k, f[k]])), arrival_date: f.arrival_date || null };
      if (item.id) await api.put(`/phones/${item.id}`, payload); else await api.post("/phones", payload);
      toast.success("Telefono salvato");
      onSaved();
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-xl" data-testid="phone-dialog">
        <DialogHeader>
          <DialogTitle>{item.id ? `Telefono ${item.imei}` : "Nuovo telefono"}</DialogTitle>
          <DialogDescription>L'assegnatario si imposta dalla lista, con la firma.</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, l]) => (
            <F key={k} label={l}><Input value={f[k] || ""} onChange={set(k)} inputMode={["imei", "sim_imei", "phone_number"].includes(k) ? "numeric" : undefined} data-testid={`phone-${k}-input`} /></F>
          ))}
          <F label="Data arrivo (facoltativa)"><Input type="date" value={f.arrival_date} onChange={set("arrival_date")} data-testid="phone-arrival-input" /></F>
          {isAdmin && <F label="Stazione">
            <Select value={f.station_id || undefined} onValueChange={(v) => setF((p) => ({ ...p, station_id: v }))}>
              <SelectTrigger data-testid="phone-station-select"><SelectValue placeholder="Seleziona" /></SelectTrigger>
              <SelectContent>{stations.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
            </Select>
          </F>}
          <F label="Note" span><Textarea rows={2} value={f.notes || ""} onChange={set("notes")} data-testid="phone-notes-input" /></F>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annulla</Button>
          <Button onClick={save} disabled={saving || !f.imei.trim()} data-testid="phone-save-button">{saving ? "Salvataggio..." : "Salva"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
